import { cn, Heading } from "@teamworksdev/react";
import type { PropsWithChildren, ReactNode } from "react";

type OrgPageLayoutProps = PropsWithChildren<{
  className?: string;
  title: ReactNode;
}>;

export const OrgPageLayout = ({ children, className, title }: OrgPageLayoutProps) => {
  return (
    <main className={cn("flex flex-col grow", className)}>
      <header className="shrink-0 sticky top-0 z-10 h-fit py-3 px-4 flex items-center bg-white border-b border-light-200">
        {title}
      </header>
      <div className="p-6">{children}</div>
    </main>
  );
};

export const OrgPageTitle = ({ children }: PropsWithChildren) => {
  return (
    <Heading as="h1" size="h1">
      {children}
    </Heading>
  );
};
